import React, { Fragment } from 'react';

export interface MaskedCardProps {
    lastDigits: string;
}

export const MaskedCard = (props: MaskedCardProps) => {
    const text = props.lastDigits.padStart(8, '•').match(/.{4}/g).join(' ');
    return <Fragment>{text}</Fragment>;
};
